import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ReviewSurvey } from 'ha/services/apiV2/types/ReviewSurvey';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (uuid: string) =>
  makeCall<ReviewSurvey>('GET', `${APIV2_URL}/review/survey/${uuid}`);
